import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";

import { useTranslations } from "../../contexts/translationContext";
import { StringWithFormat } from "../../types/Result";

export interface FormProps {
    title?: string | StringWithFormat,
    legend?: any,
    actions?: JSX.Element
    footer?: JSX.Element
    children?: React.ReactNode
}

const Form: React.FC<FormProps> = ({ title, legend, actions, footer, children }) => {
    const [formTitle, setTitle] = useState<string>('');
    const { translate } = useTranslations();

    if (title) {
        if (typeof title === 'string') {
            translate(title, undefined, title).then(translated => setTitle(translated));
        } else {
            translate(title.format, undefined, title).then(translated => setTitle(translated));
        }
    }

    const dividerStyle: React.CSSProperties = { width: '10%', height: 5, margin: '-6px 0 10px 15px', backgroundColor: '#23ccef', display: 'block' };
    const titleStyle: React.CSSProperties = {float:'left', margin: 0}
    const actionButtonsStyle: React.CSSProperties = { float: 'right' }

    return (
        <Container fluid>
            <Row>
                <Col md={12}>
                    <form>
                        <div className="card">
                            <div className="header">
                                <h4 style={titleStyle}>{formTitle}</h4>
                                <div style={actionButtonsStyle}>{actions}</div>
                            </div>
                            {formTitle && <div style={dividerStyle} />}
                            <div className="content">
                                {children}
                            </div>
                            <div className="footer">
                                {footer}
                            </div>
                        </div>
                    </form>
                </Col>
            </Row>
        </Container>
    );
}
export default Form;